// extracted by mini-css-extract-plugin
module.exports = {"ToastWrapper":"ToastWrapper-2nAdR","Icon":"Icon-1g0GU","Text":"Text-1u0fL","CloseButton":"CloseButton-17_BV"};